import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { PropertyActions } from './property.actions';
import { catchError, map, mergeMap, of } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { PropertyService } from '@core/services/property.service';

@Injectable()
export class PropertyEffects {
  private actions$ = inject(Actions);
  private propertyService = inject(PropertyService);
  private translateService = inject(TranslateService);
  getProperties$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PropertyActions.loadProperties),
      mergeMap((data) =>
        this.propertyService.getProperties(data).pipe(
          map((properties) =>
            properties.success
              ? PropertyActions.loadPropertiesSuccess(properties)
              : PropertyActions.loadPropertiesFailure(properties)
          ),
          catchError((error) =>
            of(
              PropertyActions.loadPropertiesFailure({
                error,
                success: false,
                message: this.translateService.instant('Something went wrong'),
              })
            )
          )
        )
      )
    )
  );

  addProperty$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PropertyActions.addEditProperty),
      mergeMap((data) =>
        this.propertyService.addProperty(data).pipe(
          map((property) => {
            if (property.success) {
              return data.id
                ? PropertyActions.updatePropertySuccess(property)
                : PropertyActions.addPropertySuccess(property);
            } else return PropertyActions.addPropertyFailure(property);
          }),
          catchError((error) =>
            of(
              PropertyActions.addPropertyFailure({
                error,
                success: false,
                message: this.translateService.instant('Something went wrong'),
              })
            )
          )
        )
      )
    )
  );

  deleteProperty$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PropertyActions.deleteProperty),
      mergeMap((data) =>
        this.propertyService.deleteProperty(data.id).pipe(
          map((response) =>
            response.success
              ? PropertyActions.deletePropertySuccess({
                  ...response,
                  id: data.id,
                })
              : PropertyActions.deletePropertyFailure(response)
          ),
          catchError((error) =>
            of(
              PropertyActions.deletePropertyFailure({
                error,
                success: false,
                message: this.translateService.instant('Something went wrong'),
              })
            )
          )
        )
      )
    )
  );
}
